module.exports = __webpack_public_path__ + "img/Ticket Star (1).7c21c3d9.svg";